module.exports = __webpack_public_path__ + "img/授权管理.69dfe901.png";